import React, { Component } from "react";
import Logout from "./Logout";
import { connect } from "react-redux";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css';
import PropTypes from 'prop-types';

class TopHeader extends Component {
  
  render() {

    const { userName } = this.props;

    return (
      <nav>
        <div className="logo">
          <div className="logo-img">
            {<img alt="Invinsense" src="images/Invinsense_symbol.png" /> || <Skeleton height={60} width={60}/>}
          </div>
          <div ms-code-skeleton="1000" className="logo-name">
            <a href="/">{"Invinsense" || <Skeleton/>}</a>
          </div>
        </div>
        <div className="admin-info">
        {userName && <>
          {/* <Skeleton/> */}
          <div className="admin-img">
            {userName[0].toUpperCase() || <Skeleton/>} 
          </div>
          <div className="admin-name">
          {/* <Skeleton/> */}
            <p ms-code-skeleton="1000">
              {userName || <Skeleton/>}
            </p>
          </div>
          </>}
          {/* Assuming Logout is a component */}
          {/* <Logout /> */}
          <Logout/>
          {/* <div className="logout-btn" style={{display: "flex"}}>
            <div className="div-block-2"><img src="images/setting.png" loading="lazy" alt="" /></div>
          <p className="paragraph-4">Log out</p>
        </div> */}
        </div>
      </nav>

      
    );
  }
}

TopHeader.propTypes  = {
  userName: PropTypes.string,
};

const mapStateToProps = (state) => {
  return { userName: state.posts[0]?.username };
};

export default connect(mapStateToProps)(TopHeader);